import { relayPagination } from "@urql/exchange-graphcache/extras";

export default {
  Query: {
    waitApproveReward: relayPagination(),
    collections: relayPagination(),
    myNfts: relayPagination()
  }
};
